import FormattedMessage from 'I18n/components/FormattedMessage';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Wizard, WizardStep } from 'foundations-components/transitional/components/Wizard';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import { ReviewWizardSubmitSection } from './ReviewWizardSubmitSection';
import { ReviewContextProvider, useReviewContext } from './ReviewContextProvider';
import { jsx as _jsx } from "react/jsx-runtime";
function ContextualizedReviewWizard({
  children,
  HeaderComponent,
  onClose,
  onSubmit,
  showLegalCheckbox
}) {
  const {
    review
  } = useReviewContext();
  const DoneButton = props => /*#__PURE__*/_jsx(ReviewWizardSubmitSection, {
    buttonProps: props,
    showLegalCheckbox: showLegalCheckbox
  });
  const gridItemOffset = {
    xs: 0,
    md: 1,
    lg: 3
  };
  const gridItemSize = {
    xs: 12,
    md: 10,
    lg: 6
  };
  const {
    gridItemFlexGrow
  } = useResponsiveProps({
    gridItemFlexGrow: Object.entries(gridItemSize).reduce((result, [key, value]) => {
      result[key] = value / 12;
      return result;
    }, {})
  });
  return /*#__PURE__*/_jsx(Modal, {
    use: "fullscreen",
    children: /*#__PURE__*/_jsx(Wizard, {
      cancellable: true,
      defaultDoneButton: DoneButton,
      defaultDoneLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "trellisEcosystem.reviews.submit"
      }),
      headerComponent: HeaderComponent,
      onConfirm: () => onSubmit(review),
      onReject: onClose,
      children: /*#__PURE__*/_jsx(WizardStep, {
        children: /*#__PURE__*/_jsx(Grid, {
          paddingBlockStart: "400",
          children: /*#__PURE__*/_jsx(GridItem, {
            flexGrow: gridItemFlexGrow,
            offset: gridItemOffset,
            size: gridItemSize,
            children: children
          })
        })
      })
    })
  });
}
export function ReviewWizard({
  children,
  customValidationErrors = [],
  defaultReview = {
    content: {},
    ratings: {},
    tags: {}
  },
  HeaderComponent,
  onChange,
  onClose,
  onSubmit,
  showLegalCheckbox,
  validationSchema
}) {
  return /*#__PURE__*/_jsx(ReviewContextProvider, {
    customValidationErrors: customValidationErrors,
    defaultReview: defaultReview,
    onChange: onChange,
    validationSchema: validationSchema,
    children: /*#__PURE__*/_jsx(ContextualizedReviewWizard, {
      HeaderComponent: HeaderComponent,
      onClose: onClose,
      onSubmit: onSubmit,
      showLegalCheckbox: showLegalCheckbox,
      children: children
    })
  });
}